import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'indent'
})
export class IndentPipe implements PipeTransform {
  transform(value: string | string[]): string {
    // Check if value is not undefined or null
    if (value === undefined || value === null) {
      return ''; // or handle it as you need
    }

    // If value is an array, join its elements with newline characters
    if (Array.isArray(value)) {
      return value.map(line => this.indentLine(line)).join('\n');
    }

    // Check if value is already a string
    if (typeof value !== 'string') {
      // If not, try converting it to a string
      try {
        value = JSON.stringify(value); // Convert to string using JSON.stringify
      } catch (e) {
        console.error('Error converting value to string:', e);
        return ''; // Return empty string or handle error as needed
      }
    }

    // Split the text by newline character
    const lines = value.split('\n');
    // Indent each line and join them back together with newline characters
    return lines.map(line => this.indentLine(line)).join('\n');
  }

  private indentLine(line: string): string {
    // Add four spaces of indentation to the beginning of the line
    return '    ' + line.trim();
  }
}
